import { render } from "./AgentAddEdit.vue?vue&type=template&id=0496cb6a&scoped=true"
import script from "./AgentAddEdit.vue?vue&type=script&lang=js"
export * from "./AgentAddEdit.vue?vue&type=script&lang=js"

import "./AgentAddEdit.vue?vue&type=style&index=0&id=0496cb6a&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\taxbpo_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0496cb6a"]])

export default __exports__